import Link from "next/link";
import Image from 'next/image';



const ReturnAndExchange = () => {

  return (
    <>
      <div className="md:container">
        <div className="relative hidden w-full md:block">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/return-and-exchange-desktop.jpg"}
            alt="return and exchange image"
            width={1800}
            height={422}
            quality={100}
          />
          <h1 className="absolute text-5xl text-white font-dmsans font-medium -tracking-[2.4px] top-1/2 -translate-y-1/2 pl-[104px]">
            Return & Exchange Policy
          </h1>
        </div>
        <div className="w-full md:hidden">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/return-and-exchange-mobile.jpg"}
            alt="return and exchange image"
            width={900}
            height={600}
            quality={100}
          />
        </div>
      </div>
      <div className="container flex justify-center mt-12 mb-20">
        <div className="w-full md:w-[680px] font-dmsans text-[#2C3E2F]">
          <h1 className="md:hidden mb-12 text-2xl font-medium leading-normal -tracking-[1.2px] text-center">
            Return & Exchange Policy
          </h1>
          <p className="text-base font-normal leading-loose -tracking-[0.8px]">
            We don&apos;t handle exchanges. You can make a new order on our website or through our email. Our team is here to help you find the right fit!
          </p>
          <p className="text-base font-normal leading-loose -tracking-[0.8px] mt-4">
            Regrettably, we are unable to accommodate return orders at this time.
          </p>
          {/* <h2 className="text-base md:text-xl font-bold leading-normal -tracking-[1px]">
            Cancel Order
          </h2>
          <div className="border-t-[0.5px] border-[#C6C6C6] my-4 w-full"></div>
          <p className="text-base font-normal leading-loose -tracking-[0.8px]">
            We accept order cancellation before the product is shipped. If the order is canceled you will get a full refund. We cannot cancel the order if the product is already shipped out. To proceed you cancellation, please contact our Customer Service (<Link href="mailto:cs@green-parenting.com" className="underline">cs@green-parenting.com</Link>)
          </p>
          <h2 className="mt-12 text-base md:text-xl font-bold leading-normal -tracking-[1px]">
            Product Warranty
          </h2>
          <div className="border-t-[0.5px] border-[#C6C6C6] my-4 w-full"></div>
          <p className="text-base font-normal leading-loose -tracking-[0.8px]">
            The product&apos;s warranty period is 7 days. The warranty period is calculated from the date the package is delivered to the consumer.If the product has problems or malfunctions during the warranty period, please contact us at cs@mooimom.com. We will provide after-sales warranty service within 2-3 working days.
          </p>
          <h2 className="mt-12 text-base md:text-xl font-bold leading-normal -tracking-[1px]">
            Return Policy
          </h2>
          <div className="border-t-[0.5px] border-[#C6C6C6] my-4 w-full"></div>
          <p className="text-base font-normal leading-loose -tracking-[0.8px]">
            The dear beloved customer here is the exchange instruction and policy: We are sorry that you are not 100% satisfied with our products. We accept exchange of the goods within 7 days, starting from the day you have received your order.To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging. To complete your return, we require a receipt or proof of purchase.
          </p>
          <h2 className="mt-12 text-base md:text-xl font-bold leading-normal -tracking-[1px]">
            Return & Exchange Conditions
          </h2>
          <div className="border-t-[0.5px] border-[#C6C6C6] my-4 w-full"></div>
          <ul className="text-base font-normal leading-loose -tracking-[0.8px] list-decimal pl-4">
            <li>The return and exchange period is 7 days after you have received your order, overdue requests will not be processed.</li>
            <li>The items returned must remain unused in their original packaging. We do not accept returned products that are worn, damaged, or changed in any way.</li>
            <li>Items with non-returnable marks and free gifts cannot be returned.</li>
            <li>Please be sure to double-check your returns before shipping them out. We are not responsible for the return of non-Green Parenting products.</li>
            <li>You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund.</li>
            <li>We do not accept returned items that have been sent back without proper returns requests.</li>
            <li>Since the electric breast pump is a personal product with hygiene issues, we only accept exchange items for the pump motor. Item must be returned undamaged with all serial numbers remaining. Any damage caused by man-made factors cannot be accepted for exchange. Please contact our customer service at <Link href="mailto:cs@green-parenting.com" className="underline">cs@green-parenting.com</Link> to get the return address.</li>
            <li>We only replace items if there is any noticeable defect or damage. If you need to exchange it for the same item, send us an email at <Link href="mailto:cs@green-parenting.com" className="underline">cs@green-parenting.com</Link>.</li>
            <li>If you need to exchange your product for a different size/color, items must be returned in their original packaging and unused. Once an exchange is initiated, you have 7 days to return your product and you are responsible for all shipping charges. Send us an email at <Link href="mailto:cs@green-parenting.com" className="underline">cs@green-parenting.com</Link> to start the exchange process.</li>
          </ul>
          <h2 className="mt-12 text-base md:text-xl font-bold leading-normal -tracking-[1px]">
            How to Return a Product
          </h2>
          <div className="border-t-[0.5px] border-[#C6C6C6] my-4 w-full"></div>
          <p className="text-base font-normal leading-loose -tracking-[0.8px]">
            If you meet the conditions for return and exchange, please follow the instructions:
            <ul className="pl-4 list-decimal">
              <li>Please first, contact our customer service and note that we only accept return-authorized items.</li>
              <li>Please provide your order number, order date, and a brief reason why you are requesting a refund.</li>
              <li>Our CS will respond via email to let you know if your refund request has been approved during our office hour.</li>
              <li>After receiving our return instructions, please ship the items to be returned in the original packaging to the address provided to you by Customer Service. You are responsible for all shipping charges, and we recommend you insure the shipment to cover the risk of loss or damage while in transit.</li>
              <li>Write the order number on the outside of the box.</li>
              <li>Once a return is initiated, you have 7 days to deliver your product.</li>
              <li>Most returns will be processed within 5-7 working days after we receive your package.</li>
            </ul>
          </p>
          <p className="mt-12 text-base font-normal leading-loose -tracking-[0.8px]">
            Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.If you are approved, then your refund will be processed within 3-5 working days.
          </p>
          <p className="mt-12 text-base font-normal leading-loose -tracking-[0.8px]">
            <b>PLEASE NOTE : THE SHIPPING FEE AND TAX ARE NON-REFUNDABLE</b> If you have not received a refund yet, first check your bank account again.If you have done all of this and you still have not received your refund yet, please contact us at <Link href="mailto:cs@green-parenting.com" className="underline">cs@green-parenting.com</Link>.
          </p> */}
        </div>
      </div>
    </>
  )
}

export default ReturnAndExchange
